export const GET = 'GET'
export const PUT = 'PUT'
export const POST = 'POST'
export const DELETE = 'DELETE'

export const AUTH = 'AUTH'
export const USER = 'USER'
export const PAGE_HEADING = 'PAGE_HEADING'

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const AUTH_VERIFY = 'AUTH_VERIFY'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const RESET_PASSWORD_AUTH = 'RESET_PASSWORD_AUTH'

export const USER_LOCAL_CONFIG = 'USER_LOCAL_CONFIG'